// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_bIY8xz00J2dj9CEbJO", // 70s
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/8wM00TgrYffUd7a5lq", // 70s

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "70s Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - 70s Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - 70s Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to 70s Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate images 70s style images, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "gen_70s_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/gen-70s-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;